module.exports = __webpack_public_path__ + "media/B-A-005_SAF_BTB_PhysicalSecurity.de969651.mp4";